import { useAssertedActiveTabId } from 'hooks/use-asserted-active-tab-id';
import { AmountField } from 'routes/essential-workspace/components/form/fields/amount';
import { BooleanField } from 'routes/essential-workspace/components/form/fields/boolean';
import { CurrencyField } from 'routes/essential-workspace/components/form/fields/currency';
import { CurrencyPairSwitcherField } from 'routes/essential-workspace/components/form/fields/currency-pair-switcher';
import { DateField } from 'routes/essential-workspace/components/form/fields/date';
import { DebugField } from 'routes/essential-workspace/components/form/fields/debug';
import { DigitField } from 'routes/essential-workspace/components/form/fields/digit';
import { ListField } from 'routes/essential-workspace/components/form/fields/list';
import { LockableDigitFieldEssential } from 'routes/essential-workspace/components/form/fields/locked-digit-field/locked-digit-field';
import { MultipleBadgeField } from 'routes/essential-workspace/components/form/fields/multiple-badge';
import { MultipleUnitField } from 'routes/essential-workspace/components/form/fields/multiple-unit';
import { PayoffGraphField } from 'routes/essential-workspace/components/form/fields/payoff-graph';
import { RadioButtonsField } from 'routes/essential-workspace/components/form/fields/radio-buttons';
import { SingleUnderlying } from 'routes/essential-workspace/components/form/fields/single-underlying';
import { TenorField } from 'routes/essential-workspace/components/form/fields/tenor';
import { TextField } from 'routes/essential-workspace/components/form/fields/text';
import { Underlyings } from 'routes/essential-workspace/components/form/fields/underlyings';
import { EssentialFieldNode } from 'routes/essential-workspace/state/model';

export function FieldItem(props: EssentialFieldNode) {
  const { type } = props;
  const activeTab = useAssertedActiveTabId();

  switch (type) {
    case 'Technical':
      return null;
    case 'ListField':
      return <ListField {...props} />;
    case 'SearchEditableField':
    case 'SingleSearchEditableField':
    case 'UnderlyingsSearch':
      return <Underlyings {...props} key={activeTab} />;
    case 'SingleUnderlyingField':
      return <SingleUnderlying {...props} key={activeTab} />;
    case 'NumberField':
    case 'PercentField':
      return <DigitField {...props} />;
    case 'LockablePercentField':
      return <LockableDigitFieldEssential {...props} />;
    case 'LockableAmountField':
      return <LockableDigitFieldEssential {...props} />;
    case 'CustomizableTenorField':
      return <TenorField {...props} />;
    case 'AmountField':
      return <AmountField {...props} />;
    case 'DateField':
      return <DateField {...props} />;
    case 'CurrencyListField':
      return <CurrencyField {...props} />;
    case 'CurrencyPairSwitcherField':
      return <CurrencyPairSwitcherField {...props} />;
    case 'TextField':
      return <TextField {...props} />;
    case 'CheckboxField':
      return <BooleanField {...props} />;
    case 'RadioButtonsField':
      return <RadioButtonsField {...props} />;
    case 'JointLineScatterChartField':
      return <PayoffGraphField {...props} />;
    case 'MultipleUnitsField':
      return <MultipleUnitField {...props} />;
    case 'MultipleLabelField':
      return <MultipleBadgeField {...props} />;
    default:
      return <DebugField {...props} />;
  }
}
